// extracted by mini-css-extract-plugin
export default {"DhammaListPage":"DhammaListPage_DhammaListPage__vv56K"};